import React, { useContext } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import TeachersPortal from "./components/TeachersPortal";
import ParentsPortal from "./components/ParentsPortal";
import FinishSignUp from "./components/FinishSignUp";
import ChildPage from "./components/ChildPage";
import ObservationsPrintPage from "./components/ObservationsPrintPage";
import ObservationsPage from "./components/ObservationsPage";
import ManagerPage from "./components/ManagerPage";
import StickersPage from "./components/StickersPage";
import CustomerPage from "./components/CustomerPage";
import { Box, CssBaseline, ThemeProvider } from "@mui/material";
import Menu from "./Menu";
import ScrollToTop from "./shared/ScrollToTop";
import { AppProvider, AppContext } from "./Store";
import theme from "./shared/theme";
import "./App.css";
import { SnackbarProvider } from "./shared/SnackbarProvider";

const domain = window.location.hostname;
// In dev mode, use environment variable to control portal type
// In production, use hostname to determine portal type
const envPortalMode = import.meta.env.VITE_PORTAL_MODE as 'teacher' | 'parent' | undefined;
const isTeacherPortal = envPortalMode ? envPortalMode === 'teacher' : domain.includes('teachers');
const portalType = isTeacherPortal ? 'teacher' : 'parent';

document.title = (portalType === 'teacher' ? 'Teachers Portal' : 'Parents Portal') + " | " + document.title;

const App = () => {
  const { userContext } = useContext(AppContext); // get userContext from AppProvider

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <SnackbarProvider>
        <AppProvider portalType={portalType}>
          <BrowserRouter>
            <ScrollToTop />
            <Box sx={{ flexGrow: 1 }}>
              <Menu />
              <Routes>
                {isTeacherPortal ? (
                  <>
                    <Route path="/" element={<TeachersPortal />} />
                    <Route path="/child/:childId" element={<ChildPage />} />
                    <Route path="/child/:childId/observations-report" element={<ObservationsPrintPage />} />
                    <Route path="/observations" element={<ObservationsPage />} />
                    <Route path="/driving" element={<ManagerPage />} />
                    <Route path="/stickers" element={<StickersPage />} />
                    <Route path="/customers" element={<CustomerPage />} />
                  </>
                ) : (
                  <>
                    <Route path="/" element={<ParentsPortal />} />
                    <Route path="/child/:childId" element={<ChildPage />} />
                    <Route path="/finishSignUp" element={<FinishSignUp />} />
                  </>
                )}
              </Routes>
            </Box>
          </BrowserRouter>
        </AppProvider>
      </SnackbarProvider>
    </ThemeProvider>
  );
}

export default App;
